var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtomicForceMicroscope50(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.33,
    y: 149.38,
    width: 51.48,
    height: 45.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.34,
    y: 167.73,
    width: 88.04,
    height: 26.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.04,
    y: 84.36,
    width: 72.64,
    height: 65.95
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "46.74 54.9 46.74 34.05 88.81 34.05 88.81 181.19 104.55 181.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.24,
    y: 133.87,
    width: 27.66,
    height: 15.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.67,
    y: 54.9,
    width: 10.78,
    height: 79.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.16,
    y1: 150.68,
    x2: 150.16,
    y2: 166.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 131.27,
    y1: 129.18,
    x2: 131.27,
    y2: 131.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 144.52,
    y1: 129.18,
    x2: 144.52,
    y2: 131.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.77,
    y1: 129.18,
    x2: 157.77,
    y2: 131.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.01,
    y1: 129.18,
    x2: 171.01,
    y2: 131.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 131.27,
    y1: 103.11,
    x2: 131.27,
    y2: 105.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 144.52,
    y1: 103.11,
    x2: 144.52,
    y2: 105.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 157.77,
    y1: 103.11,
    x2: 157.77,
    y2: 105.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.01,
    y1: 103.11,
    x2: 171.01,
    y2: 105.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.13,
    y1: 115.93,
    x2: 137.13,
    y2: 117.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 150.38,
    y1: 115.93,
    x2: 150.38,
    y2: 117.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 163.63,
    y1: 115.93,
    x2: 163.63,
    y2: 117.88
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomicForceMicroscope50);
export default __webpack_public_path__ + "static/media/ATOMIC_FORCE_MICROSCOPE_50.79f54e4b1960884a76a81ae046f3a4ae.svg";
export { ForwardRef as ReactComponent };